var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.filterListBulk
    ? _c(
        "div",
        _vm._l(_vm.facets, function(facet) {
          return _c("item-filter", {
            key: facet.id,
            attrs: {
              facet: facet,
              "padding-classes": _vm.paddingClasses,
              "padding-inline-styles": _vm.paddingInlineStyles
            }
          })
        }),
        1
      )
    : _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.facets && _vm.facets.length > 0,
              expression: "facets && facets.length > 0"
            }
          ],
          staticClass: "filter-wrapper"
        },
        [
          _c(
            "a",
            {
              staticClass: "btn btn-link filter-toggle d-none",
              attrs: {
                "data-toggle": "collapse",
                href: "#filter-collapse_" + _vm._cid,
                "aria-expanded": "false",
                "aria-controls": "filter-collapse_" + _vm._cid
              }
            },
            [
              _c("i", {
                staticClass: "fa fa-sliders default-float",
                attrs: { "aria-hidden": "true" }
              }),
              _vm._v(
                " " +
                  _vm._s(_vm.$translate("Ceres::Template.itemFilter")) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "open-filter-toolbar",
                  rawName: "v-open-filter-toolbar"
                }
              ],
              staticClass: "filter-collapse",
              attrs: { id: "filter-collapse_" + _vm._cid }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "container-max page-content component-loading px-0 px-lg-3",
                  class: { "is-loading": _vm.isLoading }
                },
                [
                  _c(
                    "div",
                    { staticClass: "card-columns" },
                    _vm._l(_vm.facets, function(facet) {
                      return _c("item-filter", {
                        key: facet.id,
                        attrs: { facet: facet }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row d-none" }, [
                    _c("div", { staticClass: "col-12 text-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-medium-large",
                          attrs: {
                            type: "button",
                            "data-toggle": "collapse",
                            href: "#filter-collapse_" + _vm._cid,
                            "aria-controls": "filter-collapse_" + _vm._cid
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-times",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$translate("Ceres::Template.itemClose")
                              ) + " "
                            )
                          ])
                        ]
                      )
                    ])
                  ])
                ]
              )
            ]
          )
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }